export function buildSubUnitSelectionRequest(subUnitId, anySubUnit = false) {
    return {
        sub_unit: subUnitId,
        any_sub_unit: anySubUnit ? 1 : 0
    };
}
